<template>

    <div class="list">

        <div class="container">

            <!--            MOBILE-->
            <div v-if="!isDesktop" v-for="(item, index) in localList" @click="toggleItem(index)">

                <div v-if="innerWidth<500" class="mobile-small">
                    <list-item-mobile :item="item"></list-item-mobile>
                </div>
                <div v-else class="mobile-big">
                    <list-item-desktop :item="item"></list-item-desktop>
                </div>
            </div>


            <!--            DESKTOP-->
            <div v-if="isDesktop" class="desktop">

                <list-header-desktop :twoColumns="twoColumns"
                                     :mainList="mainList"
                                     :secondList="secondList"
                                     :isSpamList="showSpamColumn"></list-header-desktop>

                <div class="row-list">

                    <template v-if="oneColumn">

                        <div class="component">

                            <list-item-desktop :item="item" v-for="(item, index) in singleList"
                                               :key="index"></list-item-desktop>

                        </div>

                    </template>

                    <template v-if="twoColumns">

                        <div class="component component-left">

                            <list-item-desktop :item="item" v-for="(item, index) in mainList"
                                               :key="index"></list-item-desktop>

                        </div>

                        <div class="component component-right">

                            <list-item-desktop :item="item" v-for="(item, index) in secondList"
                                               :key="index"></list-item-desktop>

                        </div>

                    </template>

                    <div class="opacity" v-show="showActionBar"></div>

                </div>

            </div>

        </div>

        <empty-spoum-area v-if="showEmptySpoumArea"></empty-spoum-area>

        <actions-bar v-show="showActionBar"
                     :isList="true"
                     @action="action"></actions-bar>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Subscription from '../../helpers/subscription'
import ENUM from '../../assets/ENUM'

import ActionsBar from '../../components/newsletters-v2/ActionsBar'
import Checkbox from '../../components/inputs/Checkbox'
import EmptySpoumArea from '../../components/newsletters-v2/EmptySpoumArea'
import ListHeaderDesktop from '../../components/newsletters-v2/ListHeaderDesktop'
import ListItemDesktop from '../../components/newsletters-v2/ListItemDesktop.vue'
import ListItemMobile from '../../components/newsletters-v2/ListItemMobile'
import NoMailboxSelected from '../../components/newsletters-v2/NoMailboxSelected'

export default {

    name: 'list',

    components: {
        ActionsBar,
        Checkbox,
        EmptySpoumArea,
        ListHeaderDesktop,
        ListItemDesktop,
        ListItemMobile,
        NoMailboxSelected
    },

    props: {
        list: {
            type: Array,
            default: () => []
        },

        category: {
            type: String,
            default: ''
        }
    },

    watch: {
        list(newValue, oldValue) {
            this.refreshLocalList(newValue, oldValue)
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'innerWidth',
            'newslettersSort',
            'noMailboxSelectedButNewslettersWaiting',
            'searchValue'
        ]),

        showActionBar() {
            return this.localList.filter(item => item.checked).length > 0
        },

        showSpamColumn() {
            return this.spamList.length > 0 && this.innerWidth > 1100
        },

        singleList() {
            return this.localList
        },

        mainList() {
            return this.showSpamColumn
                ? this.localList.filter(item => !Subscription.isSpoum(item))
                : this.localList.filter((item, index) => index % 2 === 0)
        },

        spamList() {
            return this.localList.filter(item => Subscription.isSpoum(item))
        },

        secondList() {
            return this.showSpamColumn
                ? this.spamList
                : this.localList.filter((item, index) => index % 2 === 1)
        },

        showEmptySpoumArea() {
            return this.category === ENUM.NEWSLETTERS.CATEGORIES.SPAMS && this.list.length === 0 && !this.noMailboxSelectedButNewslettersWaiting
        },

        oneColumn() {
            return !this.twoColumns
        },

        twoColumns() {
            return this.showSpamColumn || this.innerWidth >= 1400
        }

    },

    data() {
        return {
            localList: []
        }
    },

    mounted() {
        this.refreshLocalList(this.list)
    },

    methods: {

        refreshLocalList(newList, oldList) {
            // keep checked items
            if (oldList) {
                this.localList = newList
                    .map(item => {
                        const indexItem = oldList.find(oldItem => oldItem.sender + oldItem.email === item.sender + item.email)
                        return {...item, checked: indexItem ? oldList[indexItem] && oldList[indexItem].checked : false}
                    })
            } else {
                this.localList = newList
                    .map(item => {
                        return {...item, checked: false}
                    })
            }
        },

        toggleItem(index) {
            this.localList[index].checked = !this.localList[index].checked
        },

        action(enumAction) {
            const senders = this.localList
                .filter(item => item.checked)
            this.$emit('action', {enumAction, senders})
        }
    }
}
</script>

<style lang="scss" scoped>

.list {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    flex-grow: 1;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        background-color: $timberwolf;
    }

    .container {
        width: 100%;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
        overflow-y: scroll;
        @media screen and (min-width: 500px) and (max-width: 799px) {
            margin-top: 24px;
        }

        .mobile-big {
            padding: 0 24px;
            display: flex;
            justify-content: center;
            @media screen and (min-width: 600px) {
                padding: 0 72px;
            }
        }

        .desktop {
            display: flex;
            flex-direction: column;
            justify-content: center;

            .row-list {
                position: relative;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: center;
                overflow: hidden;

                .opacity {
                    position: fixed;
                    bottom: 0;
                    left: 320px;
                    width: 100%;
                    height: 100px;
                    background: linear-gradient(rgba(0, 0, 0, 0), #F2F4F8);
                    pointer-events: none;
                }
            }

            .component {
                display: flex;
                flex-direction: column;
                align-items: center;
                flex: 1;
                padding: 8px 8px 200px;
                overflow: hidden;

                @media screen and (min-width: $above-tablet-length) {
                    padding-top: 16px;
                }
            }

            .component-left {
                align-items: flex-end;
                padding-right: 36px;
            }

            .component-right {
                align-items: flex-start;
                padding-left: 36px;
            }
        }
    }
}

</style>
